import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/referrals.svg';
import _imports_1 from '@/assets/images/icons/me.svg';
import _imports_2 from '@/assets/images/icons/users.svg';
const _withScopeId = n => (_pushScopeId("data-v-632ead51"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "28px",
    "height": "28px"
  },
  class: "mr-2",
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "mt-3 referrals-tab-pane"
};
const _hoisted_4 = {
  class: "custom-tabs-label"
};
const _hoisted_5 = {
  class: "custom-tabs-label-content"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "14px",
    "margin-right": "5px",
    "transform": "translateY(-1px)"
  },
  alt: ""
}, null, -1));
const _hoisted_7 = {
  class: "custom-tabs-label"
};
const _hoisted_8 = {
  class: "custom-tabs-label-content"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "width": "16px",
    "margin-right": "5px",
    "transform": "translateY(-1px)"
  },
  alt: ""
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageHead = _resolveComponent("PageHead");
  const _component_superior = _resolveComponent("superior");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_subordinate = _resolveComponent("subordinate");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_PageHead, {
    content: _ctx.$t('Referrals.Introduction')
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.Referrals')), 1)]),
    icon: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["content"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tabs, {
    modelValue: $data.activeName,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.activeName = $event),
    class: "demo-tabs"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "Superior",
      name: "Superior"
    }, {
      label: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.Stake')), 1)])])]),
      default: _withCtx(() => [_createVNode(_component_superior)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "Subordinate",
      name: "Subordinate"
    }, {
      label: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.Affiliates')), 1)])])]),
      default: _withCtx(() => [_createVNode(_component_subordinate)]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])])]);
}